module.exports = __webpack_public_path__ + "resources/5517512775a90293d1a87491379a657a.png";